var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0752 19.1095C15.3521 19.1095 19.63 14.8317 19.63 9.55476C19.63 4.27781 15.3521 0 10.0752 0C4.7983 0 0.52049 4.27781 0.52049 9.55476C0.52049 11.0832 0.879386 12.5278 1.51749 13.809C1.68707 14.1494 1.74351 14.5386 1.6452 14.906L0.105066 18.5539C-0.141982 19.4772 0.0126072 19.7719 0.935921 19.5249L4.724 17.9848C5.09142 17.8865 5.48056 17.943 5.82102 18.1125C7.10216 18.7506 8.54677 19.1095 10.0752 19.1095ZM6.25334 10.7491C5.85757 10.7491 5.53674 11.0699 5.53674 11.4657C5.53674 11.8615 5.85757 12.1823 6.25334 12.1823H11.5085C11.9042 12.1823 12.2251 11.8615 12.2251 11.4657C12.2251 11.0699 11.9042 10.7491 11.5085 10.7491H6.25334ZM5.53674 8.12154C5.53674 7.72578 5.85757 7.40494 6.25334 7.40494H13.8971C14.2929 7.40494 14.6138 7.72578 14.6138 8.12154C14.6138 8.5173 14.2929 8.83815 13.8971 8.83815H6.25334C5.85757 8.83815 5.53674 8.5173 5.53674 8.12154Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.ad88c8b956d51de60d0f1945649d14a6.svg";
export { ForwardRef as ReactComponent };